export default "__VITE_ASSET__65LOy729__"